<div class="overlay" [@routeAnimations]="(onLoading$ | async)" *ngIf="onLoading$ | async">
	<ids-loading size="L"></ids-loading>
</div>
